export default __webpack_public_path__ + "d36fa235a6138e4882a2244495036e0f.png";